import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/Equal_Housing_Opportunity_Logo_1x.png")